module.exports = __webpack_public_path__ + "img/partners29.08047c92.svg";